import React, { Component } from 'react';
import style from './MenuLeft.module.css';
import { v4 as uuidv4 } from 'uuid';
import { Link } from 'react-router-dom';
import * as utils from './Utils.js';


class MenuLeft extends Component {

    constructor(props) {
        //alert("Hotel");
        super(props);
        this.state = {

        };
    }


    menuList(label, page, url) {



        let key = uuidv4();

        if (page === this.props.page) {

            return (
                // <a key={key} className={style.menuList+' '+style.menuListSelect} href={url}>{label}</a>
                <Link key={key} to={url} className={style.menuList + ' ' + style.menuListSelect}>{label}</Link>
            );
        }
        else {
            //alert(url);
            return (
                // <a key={key} className={style.menuList} href={url}>{label}</a>
                <Link key={key} to={url} className={style.menuList}>{label}</Link>
            );
        }
    }


    renderHopinn() {
        let userObject = this.props.appState.userObject;



        //console.log(userObject);

        let item = [];

        let isSysAdmin = utils.IsInRole(userObject, "SystemAdmin");
        let isHopAdmin = utils.IsInRole(userObject, "HopinnAdmin");
        let isHopStaff = utils.IsInRole(userObject, "HopinnStaff");

        //let isCompanyAdmin = utils.IsInRole(userObject, "CompanyAdmin");
        //let isCompanyStaff = utils.IsInRole(userObject, "CompanyStaff");


        // item.push(this.menuList("Booking Report","BookingReport","/BookingReport"));





        if (isSysAdmin || isHopAdmin || isHopStaff) {
            item.push(this.menuList("Report", "workflow", "/workflow"));
            item.push(this.menuList("Statement List", "statementlist", "/statementlist"));
            item.push(this.menuList("Company List", "companylist", "/companylist"));
            item.push(this.menuList("Search User Company", "searchusercompany", "/searchusercompany"));
            item.push(this.menuList("Email Sentbox", "emailhistorylist", "/emailhistorylist"));
        }
        if (isSysAdmin) {
            item.push(this.menuList("Hotels List", "hotels", "/hotels"));        
            item.push(this.menuList("Room Code List", "roomcode", "/roomcode"));        
            item.push(this.menuList("User Control", "usercontrol", "/usercontrol"));
  
            item.push(this.menuList("Company Log", "companylog", "/companylog"));
            item.push(this.menuList("Hopinn Setting", "hopinnsetting", "/hopinnsetting"));
            item.push(this.menuList("TravelClick Setting", "travelclicksetting", "/travelclicksetting"));
            item.push(this.menuList("Smtp Setting", "smtpsetting", "/smtpsetting"));
            item.push(this.menuList("Adyen Setting", "adyensetting", "/adyensetting"));
            item.push(this.menuList("TravelClick Api Log", "travelclickapilog", "/travelclickapilog"));
            item.push(this.menuList("Adyen Api Log", "adyenapilog", "/adyenapilog"));
            item.push(this.menuList("Other Api Log", "otherapilog", "/otherapilog"));
            item.push(this.menuList("Bot Hopinn Log", "bothopinnlog", "/bothopinnlog"));
            item.push(this.menuList("Bot ticker log", "tickerlog", "/tickerlog"));
        }


        


        // item.push(this.menuList("Affiliated Company","affiliatedcompany","/affiliatedcompany"));  


        if (isSysAdmin) {

        }



        return (
            <div className={style.menuBox}>
                {item}
            </div>
        );
    }


    renderCompany() {
        let userObject = this.props.appState.userObject;

        //console.log(userObject);

        let item = [];

        let isSysAdmin = utils.IsInRole(userObject, "SystemAdmin");
        let isHopAdmin = utils.IsInRole(userObject, "HopinnAdmin");
        let isHopStaff = utils.IsInRole(userObject, "HopinnStaff");

        let isCompanyAdmin = utils.IsInRole(userObject, "CompanyAdmin");
        let isCompanyStaff = utils.IsInRole(userObject, "CompanyStaff");




        // item.push(this.menuList("Booking Report","BookingReport","/BookingReport"));


        if (isSysAdmin || isHopAdmin || isCompanyAdmin){      
            item.push(this.menuList("Sub-Company List", "company/subcompanylist", "/company/subcompanylist/" + userObject.companyId));          
        }



        if (isSysAdmin || isHopAdmin || isHopStaff|| isCompanyAdmin || isCompanyStaff){
            item.push(this.menuList("Report", "workflow", "/company/workflow/" + userObject.companyId));

            item.push(this.menuList("Statement List", "statementlist", "/company/statementlist/" + userObject.companyId));
            item.push(this.menuList("Statement History", "billinglist", "/company/billinglist/" + userObject.companyId));
        }

        // if (isSysAdmin){
        //     item.push(this.menuList("Reservation by billing", "reservationbybilling", "/company/reservationbybilling/" + userObject.companyId));
        // }

        if (isSysAdmin || isHopAdmin || isCompanyAdmin){
            item.push(this.menuList("Company Setting", "company/companysetting", "/company/companysetting/" + userObject.companyId));
            // item.push(this.menuList("Policy", "company/policy", "/company/policy/" + userObject.companyId));
            item.push(this.menuList("CostCenter", "company/costcenter", "/company/costcenter/" + userObject.companyId));
            item.push(this.menuList("Employee/Approver", "company/employee", "/company/employee/" + userObject.companyId));
            item.push(this.menuList("User Group", "company/employeegroup", "/company/employeegroup/" + userObject.companyId));
            item.push(this.menuList("User List", "company/usercontrol", "/company/usercontrol/" + userObject.companyId));                 
        }
        if (isSysAdmin || isHopAdmin){
            // item.push(this.menuList("Company Link", "company/companylink", "/company/companylink/" + userObject.companyId));
            item.push(this.menuList("Company Code", "company/companycode", "/company/companycode/" + userObject.companyId));
            item.push(this.menuList("Open API", "company/openapi", "/company/openapi/" + userObject.companyId));
        }


        if (userObject.UserType === 0) {
            item.push(this.menuList("Return to hopInn menu", "undefined", "/workflow"));
        }



        // item.push(this.menuList("Company List","companylist","/companylist"));
        // item.push(this.menuList("Affiliated Company","affiliatedcompany","/affiliatedcompany"));  
        // item.push(this.menuList("Hotels List","hotels","/hotels"));
        // item.push(this.menuList("User Control","usercontrol","/usercontrol"));

        // if(isSysAdmin === true){
        //     item.push(this.menuList("TravelClick Setting","travelclicksetting","/travelclicksetting"));
        //     item.push(this.menuList("TravelClick Api Log","travelclickapilog","/travelclickapilog"));
        // }



        // return (
        //     <div className={style.menuBox}>
        //         {item}
        //     </div>
        // );
        return (
            <div className={style.menuBox}>
                <div className={style.menuTitle}>COMPANIES INFO MENU</div>
                <div className={style.companyName}>{userObject.companyName}</div>
                {/* {companyItem} */}
                {/* <a href={url}><div className={style.conpanyName}>{companyObject.CompanyName}</div></a> */}
                <div className={style.line}></div>
                {item}
            </div>
        );
    }




    render() {
        //let userObject = this.props.appState.userObject;
        let result = [];

        //alert(this.props.site);

        if (this.props.site === "company") {
            result = this.renderCompany();
        }
        else {
            result = this.renderHopinn();
        }
        return result;
    }
}
export default MenuLeft;